var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVideoAsset = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.05 12.25V2.74998C17.05 1.70498 16.195 0.849976 15.15 0.849976H2.79999C1.75499 0.849976 0.899994 1.70498 0.899994 2.74998V12.25C0.899994 13.295 1.75499 14.15 2.79999 14.15H15.15C16.195 14.15 17.05 13.295 17.05 12.25ZM6.59999 11.3V3.69998L12.3 7.49998L6.59999 11.3Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVideoAsset);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/videoAsset.e9dcb2e25af87cd93a140ee30324d34c.svg";